export default {
  data: {
    isActive: {}
  },
  methods: {
    showExplanation: function(key) {
      this.$set(this.isActive, key, !this.isActive[key])
    },
    beforeEnter(el) {
      el.style.height = '0'
    },
    enter(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    leave(el) {
      el.style.height = '0'
    }
  }
}
